<template>
    <layouts-header></layouts-header>

    <cage-breadcrumb :title="title" :text="text" :text1="text1" />

    <cage-tabset></cage-tabset>

    <!-- Page Content -->
    <div class="content">
        <div class="container">
            <section class="">
                <div class="text-center mb-40">
                    <h3 class="mb-1">Payment</h3>
                    <p class="sub-title mb-0">Secure your booking, complete payment, and enjoy our sophisticated facilities
                    </p>
                </div>
                <div class="master-academy dull-whitesmoke-bg card mb-40">
                    <div class="row d-flex align-items-center justify-content-center">
                        <div class="d-sm-flex justify-content-start align-items-center">
                            <a href="javascript:void(0);"><img class="corner-radius-10" src="@/assets/img/master-academy.png"
                                    alt="Venue"></a>
                            <div class="info">
                                <h3 class="mb-2">Manchester Academy</h3>
                                <p>Manchester Academy: Where dreams meet excellence in sports education and training.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row checkout">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-7">
                        <div class="card booking-details">
                            <h3 class="border-bottom">Order Summary</h3>
                            <ul class="list-unstyled">
                                <li><i class="fa-regular fa-building me-2"></i>Standard Synthetic Court 1<span
                                        class="x-circle"></span></li>
                                <li><i class="feather-calendar me-2"></i>27, April 2023</li>
                                <li><i class="feather-clock me-2"></i>01:00 PM to 03:00 PM</li>
                                <li><i class="feather-users me-2"></i>2 Adults, 1 Children</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-5">
                        <aside class="card payment-modes">
                            <h3 class="border-bottom">Checkout</h3>
                            <h6 class="mb-3">Select Payment Gateway</h6>
                            <div class="radio">
                                <div class="form-check form-check-inline mb-3">
                                    <input class="form-check-input default-check me-2" type="radio"
                                        name="inlineRadioOptions" id="inlineRadio1" value="Credit Card">
                                    <label class="form-check-label" for="inlineRadio1">Credit Card</label>
                                </div>
                                <div class="form-check form-check-inline mb-3">
                                    <input class="form-check-input default-check me-2" type="radio"
                                        name="inlineRadioOptions" id="inlineRadio2" value="Paypal">
                                    <label class="form-check-label" for="inlineRadio2">Paypal</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input default-check me-2" type="radio"
                                        name="inlineRadioOptions" id="inlineRadio3" value="Wallet">
                                    <label class="form-check-label" for="inlineRadio3">Wallet</label>
                                </div>
                            </div>
                            <hr>
                            <ul class="order-sub-total">
                                <li>
                                    <p>Sub total</p>
                                    <h6>$250</h6>
                                </li>
                                <li>
                                    <p>Additional Guest</p>
                                    <h6>$25</h6>
                                </li>
                                <li>
                                    <p>Service charge</p>
                                    <h6>$70</h6>
                                </li>
                            </ul>
                            <div class="order-total d-flex justify-content-between align-items-center">
                                <h5>Order Total</h5>
                                <h5>$450</h5>
                            </div>
                            <div class="form-check d-flex justify-content-start align-items-center policy">
                                <div class="d-inline-block">
                                    <input class="form-check-input" type="checkbox" value="" id="policy">
                                </div>
                                <label class="form-check-label" for="policy">By clicking 'Send Request', I agree to
                                    Dreamsport <router-link to="/pages/privacy-policy">Privacy Policy</router-link> and <router-link
                                        to="/pages/terms-condition">Terms of Use</router-link></label>
                            </div>
                            <div class="d-grid btn-block">
                                <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                                    data-bs-target="#bookingconfirmModal">Proceed $200</button>
                            </div>
                        </aside>
                    </div>
                </div>
            </section>
        </div>
        <!-- /Container -->
    </div>
    <!-- /Page Content -->

    <layout-footer></layout-footer>

    <cage-checkout-modal></cage-checkout-modal>
</template>

<script>
export default {
    data() {
        return {
            title: 'Book A Court',
            text: 'Home',
            text1: 'Book A Court',
        }
    },
}
</script>